//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import noticeHandle from '@/libs/noticeHandle';
import { noticeMessageReadApi } from '@/api/user';
import { messageListApi } from '@/api/public';
import { roterPre } from '@/settings';
import messageHandlePopup from '@/components/common/messageHandlePopup';
export default {
  name: 'MessageDetails',
  components: {
    messageHandlePopup: messageHandlePopup
  },
  props: {
    messageData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      icon: 2,
      roterPre: roterPre,
      selectedType: ['delete', 'recall']
    };
  },
  watch: {
    messageData: {
      handler: function handler(nVal) {
        if (nVal.data.is_read === 0) {
          this.batchMessageRead(1, {
            ids: [nVal.data.id]
          });
        }
      },
      deep: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      noticeHandle(this.messageData.data, 0);
      this.handleEmit();
      this.dialogVisible = false;
    },
    beforeClose: function beforeClose() {
      this.dialogVisible = false;
    },
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
    },
    handleConfirm: function handleConfirm(item) {
      this.dialogVisible = false;
      if (this.selectedType.includes(item.action)) return false;
      this.$refs.messageHandlePopup.openMessage(item, this.messageData.data);
    },
    noticeLink: function noticeLink() {
      if (this.messageData.data.is_read === 0) {
        this.batchMessageRead(1, {
          ids: [this.messageData.data.id]
        });
      }
    },
    // 批量标记未已读
    batchMessageRead: function batchMessageRead(status, data) {
      var _this = this;
      noticeMessageReadApi(status, data).then(function (res) {
        _this.$emit('isOk');
        _this.getMessage();
        // this.$message.success(res.message);
      }).catch(function (error) {
        // this.$message.error(error.message);
      });
    },
    handleEmit: function handleEmit() {
      this.$emit('isOk');
    },
    // 消息数量
    getMessage: function getMessage() {
      var _this2 = this;
      messageListApi({
        page: 1,
        limit: 5
      }).then(function (res) {
        var num = res.data.messageNum ? res.data.messageNum : 0;
        _this2.$store.commit('user/SET_MESSAGE', num);
      });
    }
  }
};